import { FunctionComponent } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './questionTopHeader.scss';

export const QuestionTopHeader: FunctionComponent = () => {
    return (
        <div className={styles.pageHeaderWrapper}>
            <div className={styles.pageHeaderInnerWrapper}>
                <div className={styles.pageHeaderTitle}>
                    <FormattedMessage
                        id="questionsAnswers.questionTopHeader.title"
                        defaultMessage="Questions & Answers"
                    />
                </div>
                <div className={styles.pageHeaderDescription}>
                    <FormattedMessage
                        id="questionsAnswers.questionTopHeader.subtitle"
                        defaultMessage="Our trusted network of 1stDibs sellers answer common questions"
                    />
                </div>
            </div>
        </div>
    );
};
